import React from 'react';
import classNames from 'classnames';

type Props = Omit<React.HTMLAttributes<HTMLSpanElement>, 'width' | 'height'> & {size?: number};

export default function HashTagIcon({size = 16, className, ...props}: Props) {
    return (
        <span className={classNames('icon time-icon', className)} {...props} data-testid='hash-tag-icon'>
            <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>

                <path d='M4.38896 14C3.98054 14 3.67127 13.631 3.74265 13.2289L4.07911 11.3333H2.20591C1.79176 11.3333 1.47783 10.9597 1.54922 10.5517C1.60505 10.2327 1.88206 10 2.20591 10H4.31244L5.01911 6H3.14591C2.73176 6 2.41783 5.62636 2.48922 5.21841C2.54505 4.89941 2.82206 4.66667 3.14591 4.66667H5.25244L5.62963 2.54169C5.68525 2.22832 5.95766 2 6.27593 2C6.68435 2 6.99362 2.36899 6.92224 2.77113L6.58578 4.66667H10.5858L10.963 2.54169C11.0186 2.22832 11.291 2 11.6093 2C12.0177 2 12.3269 2.36899 12.2556 2.77113L11.9191 4.66667H13.7923C14.2065 4.66667 14.5204 5.04031 14.449 5.44825C14.3932 5.76726 14.1162 6 13.7923 6H11.6858L10.9791 10H12.8523C13.2665 10 13.5804 10.3736 13.509 10.7816C13.4532 11.1006 13.1762 11.3333 12.8523 11.3333H10.7458L10.3686 13.4583C10.313 13.7717 10.0406 14 9.72229 14C9.31387 14 9.00461 13.631 9.07599 13.2289L9.41244 11.3333H5.41244L5.03526 13.4583C4.97964 13.7717 4.70722 14 4.38896 14ZM6.35244 6L5.64578 10H9.64578L10.3524 6H6.35244Z' fill='currentColor' />

            </svg>

        </span>
    );
}
